import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SouthAmericaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"south_america"}/>
}
